module.exports = __webpack_public_path__ + "img/nav-bar-material.b129f585.svg";